import { render, staticRenderFns } from "./inactive.vue?vue&type=template&id=26d9d024&scoped=true&"
import script from "./inactive.vue?vue&type=script&lang=ts&"
export * from "./inactive.vue?vue&type=script&lang=ts&"
import style0 from "./inactive.vue?vue&type=style&index=0&id=26d9d024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d9d024",
  null
  
)

export default component.exports